import React from "react";
import {
    IconMealBowl,
    IconTittleCafeteria
} from "../../../../../../components/buttons/IconButtons";
import SummaryListCard from "../../../../../../components/Summary/SummaryListCard";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Diners (cafeterias) container for the foodie shift summary. Thin wrapper over
 * the shared SummaryListCard with label-only rows.
 */
const SummaryContainerCafeterias = ({ t, selected = [] }) => {

    return (
        <SummaryListCard
            headerIcon={IconTittleCafeteria}
            title={t('diners')}
            emptyText={t('no_information_cafeterias')}
            avatarIcon={IconMealBowl}
            selected={selected}
            getLabel={(item) => item.fullName || item.name}
            t={t}
        />
    )

}

export default SummaryContainerCafeterias
